const basicLabelsOneToFiveFI = ["1", "2", "3", "4", "5"];

const digicapQuestions = {
  categories: [
    {
      id: 1,
      name: {
        fi: "Palvelut ja tuotteet"
      },
      questions: [1, 2, 3, 4]
    },
    {
      id: 2,
      name: {
        fi: "Markkinointi ja viestintä"
      },
      questions: [5, 6, 7, 8]
    },
    {
      id: 3,
      name: {
        fi: "Myynti ja asiakashallinta"
      },
      questions: [9, 10, 11, 12]
    },
    {
      id: 4,
      name: {
        fi: "Tuotanto, logistiikka ja kunnossapito"
      },
      questions: [13, 14, 15, 16]
    },
    {
      id: 5,
      name: {
        fi: "Johtaminen ja tukipalvelut"
      },
      questions: [17, 18, 19, 20]
    },
    {
      id: 6,
      name: {
        fi: "Yhteenveto"
      },
      questions: []
    }
  ],
  questions: {
    C1: [
      {
        id: 1,
        header: {
          fi: "Tarjottavat digitaaliset palvelut tai tuotteet"
        },
        hint: {
          fi: [
            "(1) - Digipalveluja tai digituotteita ei ole tarjolla asiakkaille",
            "(5) - Digipalvelut tuovat merkittävän osan liikevaihdosta"
          ]
        },
        type: "radiolabels",
        defaultValue: 1,
        weight: 0.25,
        labels: {
          fi: basicLabelsOneToFiveFI
        }
      },
      {
        id: 2,
        header: {
          fi: "Tuotteiden tai palvelujen ostaminen ja tilaaminen sähköisesti"
        },
        hint: {
          fi: [
            "(1) - Ei voi tilata tai ostaa sähköisesti",
            "(5) - Kaikki palvelut ostettavissa verkkopalvelun kautta"
          ]
        },
        type: "radiolabels",
        defaultValue: 1,
        weight: 0.25,
        labels: {
          fi: basicLabelsOneToFiveFI
        }
      },
      {
        id: 3,
        header: {
          fi: "Tuotteiden ja palveluiden asiakastuki"
        },
        hint: {
          fi: [
            "(1) - Digitaalista tukea tai neuvontaa ei ole tarjolla asiakkaille",
            "(5) - Asiakkaamme saa tukea digitaalisesti chat- ja verkkopalvelujemme kautta 24/7"
          ]
        },
        type: "radiolabels",
        defaultValue: 1,
        weight: 0.25,
        labels: {
          fi: basicLabelsOneToFiveFI
        }
      },
      {
        id: 4,
        header: {
          fi: "Digitaalisten palveluketjujen kehittäminen"
        },
        hint: {
          fi: [
            "(1) - Digitaalisia palveluketjuja ja asiointia ei ole kehityksessä",
            "(5) - Digitaalisia palveluketjuja on rakennettu ja niitä kehitetään jatkuvasti"
          ]
        },
        type: "radiolabels",
        defaultValue: 1,
        weight: 0.25,
        labels: {
          fi: basicLabelsOneToFiveFI
        }
      }
    ],
    C2: [
      {
        id: 5,
        header: {
          fi:
            "Digikanavien hyödyntäminen markkinoinnissa (www-sivut, uutiskirjeet, blogit, Youtube, Facebook, Twitter, yms)"
        },
        hint: {
          fi: [
            "(1) - Digikanavia ei juurikaan hyödynnetä",
            "(5) - Digikanavat ovat tehokkaassa käytössä"
          ]
        },
        type: "radiolabels",
        defaultValue: 1,
        weight: 0.25,
        labels: {
          fi: basicLabelsOneToFiveFI
        }
      },
      {
        id: 6,
        header: {
          fi:
            "Hakukoneoptimoinnin, digimainonnan ja digiaineiston käyttö markkinoinnissa"
        },
        hint: {
          fi: [
            "(1) - Ei käytetä",
            "(5) - Hyödynnetään ja käytetään tehokkaasti"
          ]
        },
        type: "radiolabels",
        defaultValue: 1,
        weight: 0.25,
        labels: {
          fi: basicLabelsOneToFiveFI
        }
      },
      {
        id: 7,
        header: {
          fi: "Markkinoinnin automatiikan ja analytiikan hyödyntäminen"
        },
        hint: {
          fi: [
            "(1) - Ei ole käytössä ja ei hyödynnetä",
            "(5) - Hyödynnetään ja käytetään tehokkaasti"
          ]
        },
        type: "radiolabels",
        defaultValue: 1,
        weight: 0.25,
        labels: {
          fi: basicLabelsOneToFiveFI
        }
      },
      {
        id: 8,
        header: {
          fi: "Digitaalisen jalanjäljen seuranta ja analysointi"
        },
        hint: {
          fi: [
            "(1) - Digitaalisen jalanjäljen seurantaa ei tehdä",
            "(5) - Digijälkeä seurataan ja analysoidaan"
          ]
        },
        type: "radiolabels",
        defaultValue: 1,
        weight: 0.25,
        labels: {
          fi: basicLabelsOneToFiveFI
        }
      }
    ],
    C3: [
      {
        id: 9,
        header: {
          fi: "Asiakkuuden ja myynnin hallinnan järjestelmä (CRM)"
        },
        hint: {
          fi: [
            "(1) - Ei ole käytössä CRM-järjestelmää",
            "(5) - Asiakkuuksia ja myyntiä hoidetaan liikkuvaa työtä tukevalla CRM:llä"
          ]
        },
        type: "radiolabels",
        defaultValue: 1,
        weight: 0.25,
        labels: {
          fi: basicLabelsOneToFiveFI
        }
      },
      {
        id: 10,
        header: {
          fi: "Verkkokauppa tai vastaava sähköinen ostopaikka"
        },
        hint: {
          fi: [
            "(1) - Ostamista tai tilaamista ei voi tehdä sähköisesti",
            "(5) - Verkkokauppa käytössä 24/7"
          ]
        },
        type: "radiolabels",
        defaultValue: 1,
        weight: 0.25,
        labels: {
          fi: basicLabelsOneToFiveFI
        }
      },
      {
        id: 11,
        header: {
          fi: "Reaaliaikainen myynnin johtaminen ja raportointi"
        },
        hint: {
          fi: [
            "(1) - Ei sähköistä, reaaliaikaista järjestelmää",
            "(5) - Reaaliaikainen myynnin johtamisjärjestelmä käytössä"
          ]
        },
        type: "radiolabels",
        defaultValue: 1,
        weight: 0.25,
        labels: {
          fi: basicLabelsOneToFiveFI
        }
      },
      {
        id: 12,
        header: {
          fi: "Asiakkaiden ja liidien hankinta"
        },
        hint: {
          fi: [
            "(1) - Ei hyödynnetä digitaalisia kanavia",
            "(5) - Myyjät hyödyntävät aktiivisesti digikanavia"
          ]
        },
        type: "radiolabels",
        defaultValue: 1,
        weight: 0.25,
        labels: {
          fi: basicLabelsOneToFiveFI
        }
      }
    ],
    C4: [
      {
        id: 13,
        header: {
          fi:
            "Asioiden Internetin (IoT), virtuaalitodellisuuden (VR), 3D-tulostuksen ja tekoälyn hyödyntäminen"
        },
        hint: {
          fi: [
            "(1) - Ei hyödynnetä ja ei ole kehitteillä IoT, VR tai tekoäly-ratkaisuja",
            "(5) - On käytössä ja jatkuvasti kehitetään lisää"
          ]
        },
        type: "radiolabels",
        defaultValue: 1,
        weight: 0.25,
        labels: {
          fi: basicLabelsOneToFiveFI
        }
      },
      {
        id: 14,
        header: {
          fi: "Hankinta- ja ostoprosessien digitalisointi"
        },
        hint: {
          fi: [
            "(1) - Ei ole käytössä sähköisiä järjestelmiä",
            "(5) - Hankinta- ja ostotoiminnat hoidetaan sähköisesti"
          ]
        },
        type: "radiolabels",
        defaultValue: 1,
        weight: 0.25,
        labels: {
          fi: basicLabelsOneToFiveFI
        }
      },
      {
        id: 15,
        header: {
          fi: "Valmistuksen prosessit ja robotiikan hyödyntäminen"
        },
        hint: {
          fi: [
            "(1) - Ei ole digitalisoitu",
            "(5) - Prosessit hoidetaan digitaalisesti ja robotteja on käytössä"
          ]
        },
        type: "radiolabels",
        defaultValue: 1,
        weight: 0.25,
        labels: {
          fi: basicLabelsOneToFiveFI
        }
      },
      {
        id: 16,
        header: {
          fi: "Logistiikan ja kunnossapidon digitalisointi"
        },
        hint: {
          fi: [
            "(1) - Ei ole käytössä sähköisiä ratkaisuja",
            "(5) - Hoidetaan täysin digitaalisesti"
          ]
        },
        type: "radiolabels",
        defaultValue: 1,
        weight: 0.25,
        labels: {
          fi: basicLabelsOneToFiveFI
        }
      }
    ],
    C5: [
      {
        id: 17,
        header: {
          fi: "Visio ja strategia"
        },
        hint: {
          fi: [
            "(1) - Digitaalisuus ei ole olennaisessa osassa nykyistä strategiaa",
            "(5) - Digitaalisuus on merkittävässä osassa strategiaa"
          ]
        },
        type: "radiolabels",
        defaultValue: 1,
        weight: 0.25,
        labels: {
          fi: basicLabelsOneToFiveFI
        }
      },
      {
        id: 18,
        header: {
          fi: "Toimintamallit ja -prosessit"
        },
        hint: {
          fi: [
            "(1) - Ei hyödynnetä juurikaan sähköisiä ratkaisuja",
            "(5) - Prosessit ovat digitaalisia ja mitattavia"
          ]
        },
        type: "radiolabels",
        defaultValue: 1,
        weight: 0.25,
        labels: {
          fi: basicLabelsOneToFiveFI
        }
      },
      {
        id: 19,
        header: {
          fi: "Organisointi, henkilöstö, osaaminen ja kulttuuri"
        },
        hint: {
          fi: [
            "(1) - Ei ole digiosaamista eikä digikulttuuria",
            "(5) - Digitaalisuus on organisoitu, digikulttuuri vahva ja henkilöstö osaava"
          ]
        },
        type: "radiolabels",
        defaultValue: 1,
        weight: 0.25,
        labels: {
          fi: basicLabelsOneToFiveFI
        }
      },
      {
        id: 20,
        header: {
          fi: "IT ja muu teknologia"
        },
        hint: {
          fi: [
            "(1) - Käytössä oleva teknologia ei tue digitaalisuuden kehittymistä",
            "(5) - Vastaa täysin digitaalisuuden tarpeita"
          ]
        },
        type: "radiolabels",
        defaultValue: 1,
        weight: 0.25,
        labels: {
          fi: basicLabelsOneToFiveFI
        }
      }
    ]
  },
  summary: [
    {
      fi:
        "0 - 10 niin olet digitaalisuuden kärkijoukossa. Jatka vain samaan tahtiin."
    },
    {
      fi:
        "11-20 niin hyödynnät hyvin laajasti digitaalisuuden tuomia mahdollisuuksia."
    },
    {
      fi:
        "21-30 niin hyödynnät keskimääräisesti digitaalisuutta ja käytössäsi on jo useita digitaalisia ratkaisuja."
    },
    {
      fi:
        "31-40 niin olet jo ottanut ensimmäisiä askeleita digitaalisuuden hyödyntämisessä, mutta vauhtia voisi lisätä."
    },
    {
      fi:
        "yli 40 niin olisi aika alkaa tosissaan selvittämään digitalisoinnin mahdollisuuksia."
    }
  ]
};

export default digicapQuestions;
